module.exports = __webpack_public_path__ + "static/media/07_hero_tablet.e9d8a5eb.jpg";